// @flow
import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";

import { Translate, withI18n } from "@quantum/i18n";

import { compose } from "ramda";

import SelectInput from "../../../comum/SelectInput";

import { NumberField } from "@quantum/ui";

import classNames from "classnames";

import {
  getValoresBaseDeflator,
  selecionarValorBaseDeflator,
  getValorBaseDeflatorSelecionado,
  getDeflatorSelecionado,
  getCorretorMonetarioSelecionado,
  getValorBaseDeflatorOutroSelecionado,
  getSeparadorDecimal,
  isModoSeries,
  selecionarValorBaseDeflatorOutro,
  type ActionCreator,
} from "../../../../state";
import {
  type EnumCodigoDescricao,
  ID_VALOR_BASE_DEFLATOR_OUTRO,
  ID_VALOR_BASE_DEFLATOR_ORIGINAL,
  ID_VALOR_BASE_DEFLATOR_ORIGINAL_ATIVO,
  ID_VALOR_BASE_DEFLATOR_NENHUM,
  ID_VALOR_BASE_DEFLATOR_CEM,
} from "../../../../model";

type Props = {
  listaValoresBaseDeflator: Array<EnumCodigoDescricao>,
  valorBaseDeflatorSelecionado: string,
  selecionarValorBaseDeflator: ActionCreator,
  selecionarValorBaseDeflatorOutro: ActionCreator,
  deflatorSelecionado: ?number,
  corretorMonetarioSelecionado: ?number,
  exibirInputValorBaseOutro: boolean,
  valorBaseDeflatorOutro: ?number,
  separadorDecimal: string,
  forcarExibirNormalizacao?: boolean,
  exibirOpcaoNenhum?: boolean,
};

function SelecaoValorBaseDeflator({
  listaValoresBaseDeflator,
  valorBaseDeflatorSelecionado,
  selecionarValorBaseDeflator,
  selecionarValorBaseDeflatorOutro,
  deflatorSelecionado,
  corretorMonetarioSelecionado,
  exibirInputValorBaseOutro,
  valorBaseDeflatorOutro,
  separadorDecimal,
  forcarExibirNormalizacao = false,
  exibirOpcaoNenhum = false,
}: Props) {
  const modoSeries = useSelector(isModoSeries);

  useEffect(() => {
    const apenasOpcaoOriginal =
      deflatorSelecionado && corretorMonetarioSelecionado;

    if (valorBaseDeflatorSelecionado === null) {
      selecionarValorBaseDeflator(
        exibirOpcaoNenhum
          ? ID_VALOR_BASE_DEFLATOR_NENHUM
          : modoSeries
          ? ID_VALOR_BASE_DEFLATOR_CEM
          : ID_VALOR_BASE_DEFLATOR_ORIGINAL_ATIVO
      );
    } else if (
      apenasOpcaoOriginal &&
      valorBaseDeflatorSelecionado !== ID_VALOR_BASE_DEFLATOR_ORIGINAL &&
      valorBaseDeflatorSelecionado !== ID_VALOR_BASE_DEFLATOR_NENHUM
    ) {
      selecionarValorBaseDeflator(ID_VALOR_BASE_DEFLATOR_ORIGINAL);
    }
  }, [
    modoSeries,
    valorBaseDeflatorSelecionado,
    exibirOpcaoNenhum,
    selecionarValorBaseDeflator,
    deflatorSelecionado,
    corretorMonetarioSelecionado,
  ]);

  function onChange(valorBase) {
    selecionarValorBaseDeflator(valorBase);
    if (valorBase !== ID_VALOR_BASE_DEFLATOR_OUTRO) {
      selecionarValorBaseDeflatorOutro(null);
    }
  }

  function onChangeValorBaseOutro(valorBaseOutro) {
    selecionarValorBaseDeflatorOutro(valorBaseOutro);
  }

  if (!forcarExibirNormalizacao && !deflatorSelecionado) {
    return null;
  }

  const valorBaseOutroInput = exibirInputValorBaseOutro ? (
    <NumberField
      className="ConfiguracaoMedida__input"
      decimalScale={2}
      min={-999999}
      max={999999}
      onChangeValue={onChangeValorBaseOutro}
      value={valorBaseDeflatorOutro}
      thousandSeparator={""}
      decimalSeparator={separadorDecimal}
    />
  ) : null;

  return (
    <div className="ConfiguracaoMedida">
      <label className="ConfiguracaoMedida__label">
        <Translate>ConfiguracaoIndicador.ValorBase</Translate>
      </label>
      <SelectInput
        className={classNames(
          "ConfiguracaoMedida__input-select",
          "ConfiguracaoMedida__ValorBase"
        )}
        options={listaValoresBaseDeflator}
        value={valorBaseDeflatorSelecionado}
        onChange={onChange}
        size={1}
        multiple={false}
        campoDescricao="traducao"
        campoId="codigo"
      />
      {valorBaseOutroInput}
    </div>
  );
}

export default compose(
  withI18n,
  connect(
    (state, ownProps) => ({
      listaValoresBaseDeflator: getValoresBaseDeflator(state)
        .filter(valoresBaseDeflator => {
          const deflator = getDeflatorSelecionado(state);
          const corretor = getCorretorMonetarioSelecionado(state);
          const apenasOpcaoOriginal =
            ownProps.exibirOpcaoNenhum && deflator && corretor;

          if (apenasOpcaoOriginal) {
            return (
              valoresBaseDeflator.codigo === ID_VALOR_BASE_DEFLATOR_ORIGINAL ||
              valoresBaseDeflator.codigo === ID_VALOR_BASE_DEFLATOR_NENHUM
            );
          }

          return (
            ownProps.exibirOpcaoNenhum ||
            (valoresBaseDeflator.codigo !==
              ID_VALOR_BASE_DEFLATOR_ORIGINAL_ATIVO &&
              valoresBaseDeflator.codigo !== ID_VALOR_BASE_DEFLATOR_NENHUM)
          );
        })
        .map(valorBase => ({
          ...valorBase,
          traducao: ownProps.translate(valorBase.descricao),
        })),
      valorBaseDeflatorSelecionado: getValorBaseDeflatorSelecionado(state),
      // valorBaseDeflatorSelecionado: (() => {
      //   const modoApp = getModoApp(state);
      //   const valor = getValorBaseDeflatorSelecionado(state);
      //   const exibeOpcaoNenhum = ownProps.exibirOpcaoNenhum;

      //   if (valor === null) {
      //     if (exibeOpcaoNenhum) {
      //       return ID_VALOR_BASE_DEFLATOR_NENHUM;
      //     }

      //     return modoApp === MODO_APP_SERIES
      //       ? ID_VALOR_BASE_DEFLATOR_CEM
      //       : ID_VALOR_BASE_DEFLATOR_ORIGINAL_ATIVO;
      //   }

      //   return valor;
      // })(),
      deflatorSelecionado: getDeflatorSelecionado(state),
      corretorMonetarioSelecionado: getCorretorMonetarioSelecionado(state),
      exibirInputValorBaseOutro:
        getValorBaseDeflatorSelecionado(state) === ID_VALOR_BASE_DEFLATOR_OUTRO,
      valorBaseDeflatorOutro: getValorBaseDeflatorOutroSelecionado(state),
      separadorDecimal: getSeparadorDecimal(state),
    }),
    { selecionarValorBaseDeflator, selecionarValorBaseDeflatorOutro }
  )
)(SelecaoValorBaseDeflator);
